/* eslint-disable no-empty */
import { PoiWitnessContent } from "@/models/MapPois/ManHunt/ManhuntMapPoi";
import { isEmpty, isNumber, toArray } from "lodash";
import { db } from "@/api/firebase";
import { QuestMapPoi } from "@/models/MapPois/Quest/QuestMapPoi";
import { QuestPoiError } from "@/models/Errors/QuestPoiError";
import { MINIGAME_TYPE } from "@/models/MapPois/Quest/Puzzle";
import { Quests } from "@/models/MapPois/Quest/Quests";
import { InvItem, Season } from "@/models/GameType";

export default class QuestPoiErrors {
  mapPoi: QuestMapPoi;
  mapPoiArray: QuestMapPoi[];
  errorObject = {} as QuestPoiError;
  questData: Quests[];
  gameUid: string;
  seasonData: Season;
  poiWitnessContent: PoiWitnessContent[] = [];
  constructor(
    mapPoi: QuestMapPoi,
    gameUid: string,
    mapPoiArray: QuestMapPoi[],
    questData: Quests[],
    seasonData: Season
  ) {
    this.mapPoi = mapPoi;
    this.gameUid = gameUid;
    this.mapPoiArray = mapPoiArray;
    this.questData = questData;
    this.seasonData = seasonData;
  }

  checkQuestMapPoiErrors(): QuestPoiError {
    if (this.mapPoi.title.en !== "START_ZONE") {
      this.checkLocInvalid();
      this.checkGeneralHasTitle();
      this.checkGeneralHasImage();
      this.checkGeneralHasGeoRadius();
      this.checkContentGroups();

      if (!isEmpty(this.errorObject)) {
        db.ref(
          "map_poi/" + this.gameUid + "/" + this.mapPoi.key + "/issues/err/"
        ).set(this.errorObject);
      } else {
        db.ref(
          "map_poi/" + this.gameUid + "/" + this.mapPoi.key + "/issues/err/"
        ).remove();
      }
    }
    return this.errorObject;
  }

  private checkLocInvalid(): void {
    if (
      this.mapPoi.loc.loc_uid === "" &&
      this.mapPoi.loc.override_ll.latitude == 0 &&
      this.mapPoi.loc.override_ll.longitude == 0
    ) {
      this.errorObject.loc_invalid = {
        active: true,
        txt: {
          en: "General: Location is invalid or set 0,0",
        },
      };
    }
  }

  private checkGeneralHasTitle(): void {
    if (this.mapPoi.title.en.trim().length === 0) {
      this.errorObject.general_title_mia = {
        active: true,
        txt: {
          en: "General: Title is missing",
        },
      };
    }
  }

  private checkGeneralHasImage(): void {
    if (
      this.mapPoi.image === undefined ||
      this.mapPoi.image?.trim().length === 0
    ) {
      this.errorObject.general_image_mia = {
        active: true,
        txt: {
          en: "General: Image Is Missing",
        },
      };
    }
  }

  private checkGeneralHasGeoRadius(): void {
    if (
      this.mapPoi.loc.geo_rad_m === undefined ||
      (!isNumber(this.mapPoi.loc.geo_rad_m) && this.mapPoi.loc.geo_rad_m < 10)
    ) {
      this.errorObject.general_geofence_radius = {
        active: true,
        txt: {
          en: "General: Geo Radius is missing or not a number",
        },
      };
    }
  }

  public checkContentGroups(): void {
    toArray(this.mapPoi.contentGroups).forEach((x: any) => {
      //this.checkDialogHasTitle(x);
      this.checkDialogHasText(x);
      this.isDialogQuestionAnswerMia(x);
      this.isDialogTwoQuestionAnswerMia(x);
      this.isDialogInventoryCostEmpty(x);
      this.isDialogTwoInventoryCostEmpty(x);
      this.checkMiniGameCodeIsErrorFree(x);
      this.checkMiniGameColorMatchIsErrorFree(x);
      this.checkMiniGameImageMatchIsErrorFree(x);
      this.checkMiniGameInventoryPickerIsErrorFree(x);
      this.checkMiniGameLockpickIsErrorFree(x);
      this.checkMiniGameMapRunawayIsErrorFree(x);
      this.checkMiniGameMarbleMazeIsErrorFree(x);
      this.checkMiniGameMicrophoneIsErrorFree(x);
      this.checkMiniGameNumberMatchIsErrorFree(x);
      this.checkMiniGamePoiPickerIsErrorFree(x);
      this.checkMiniGameShakeIsErrorFree(x);
      this.checkMiniGameSweetSpotIsErrorFree(x);
      this.checkMiniGameSwipeImageIsErrorFree(x);
      this.checkMiniGameSymbolTrainIsErrorFree(x);
      this.checkMiniGameTapItIsErrorFree(x);
      this.checkMiniGameTileIsErrorFree(x);
      this.checkMiniGameTutorialHasDesc(x);
      this.checkMiniGameTutorialHasStyleId(x);
      this.checkMiniGameTutorialHasTitle(x);
      this.checkMiniGameMultiChoiceIsErrorFree(x);
      this.checkMiniGamePointTraceImgIsErrorFree(x);
      this.isTargetPoiMissing(x);
      this.isDialogTargetPoiMissing(x);
      this.isMGFinalTargetPoiMissing(x);
      this.isMGOnIncorrectTargetPoiMissing(x);
      this.isMGOnSuccessTargetPoiMissing(x);
      this.isMGOnFailTargetPoiMissing(x);
      this.isDialogQuestionTargetPoiMissing(x);
      this.isDialogTwoQuestionTargetPoiMissing(x);
      this.doesMapRunawayPoiExist(x);
      this.doesPoiPickerPoiExist(x);
      this.doesInventoryPickerPoiExist(x);
      this.isInventoryTargetSelected(x);
      this.isPoiPickerTargetSelected(x);
    });
  }

  private checkDialogHasTitle(x: any): void {
    if (x.d1 !== undefined && x.d1.title.en.trim().length === 0) {
      this.errorObject.dialog_title_mia = {
        active: true,
        txt: {
          en: "Dialog 1: Title is missing",
        },
      };
    }
    if (x.d2 !== undefined && x.d2.title.en.trim().length === 0) {
      this.errorObject.dialog_title_mia = {
        active: true,
        txt: {
          en: "Dialog 2: Title is missing",
        },
      };
    }
  }

  private checkDialogHasText(x: any): void {
    if (this.mapPoi.type !== "amenities") {
      if (x.d1 !== undefined && x.d1.txt.en.trim().length === 0) {
        this.errorObject.dialog_text_mia = {
          active: true,
          txt: {
            en: "Dialog 1: Text is missing",
          },
        };
      }
      if (x.d2 !== undefined && x.d2.txt.en.trim().length === 0) {
        this.errorObject.dialog_text_mia = {
          active: true,
          txt: {
            en: "Dialog 2: Text is missing",
          },
        };
      }
    }
  }

  private checkMiniGameTutorialHasTitle(x: any): void {
    if (
      x.mg !== undefined &&
      x.mg.puzzle.tutorial.title.en.trim().length === 0
    ) {
      this.errorObject.tutorial_title_mia = {
        active: true,
        txt: {
          en: "Mini Game Tutorial: Title is missing",
        },
      };
    }
  }
  private checkMiniGameTutorialHasDesc(x: any): void {
    if (x.mg !== undefined && x.mg.puzzle.tutorial.txt.en.trim().length === 0) {
      this.errorObject.tutorial_title_description_mia = {
        active: true,
        txt: {
          en: "Mini Game Tutorial: Description is missing",
        },
      };
    }
  }

  private checkMiniGameTutorialHasStyleId(x: any): void {
    if (
      x.mg !== undefined &&
      x.mg.puzzle.styleID === undefined &&
      !isNumber(x.mg.puzzle.styleID)
    ) {
      this.errorObject.tutorial_style_tag = {
        active: true,
        txt: {
          en: "Mini Game Tutorial: StyleID is missing or not a number",
        },
      };
    }
  }

  private checkMiniGameMultiChoiceIsErrorFree(x: any): void {
    try {
      if (x.mg !== undefined && x.mg.type === MINIGAME_TYPE.MULTI_CHOICE) {
        toArray(x.mg.puzzle.puzzleData).forEach((y: any) => {
          if (
            y.q.txt.en.trim().length == 0 ||
            y.q.txt.en.trim().length > 500 ||
            y.q.txt.en.toLowerCase().includes("archetypal")
          ) {
            this.errorObject.multiple_choice_question = {
              active: true,
              txt: {
                en:
                  "Mini Game Multiple Choice: Question should have a value, not greater than 500 and does not contain archetypal ",
              },
            };
          }
          if (y.a.a0.txt.en.trim().length === 0) {
            this.errorObject.multiple_choice_valid_answer = {
              active: true,
              txt: {
                en: "Mini Game Multiple Choice: One Answer should have a value",
              },
            };
          }
        });
      }
    } catch (error) {}
  }

  private checkMiniGamePointTraceImgIsErrorFree(x: any): void {
    try {
      if (x.mg !== undefined && x.mg.type === MINIGAME_TYPE.POINT_TRACE) {
        toArray(x.mg.puzzle.puzzleData).forEach((y: any) => {
          if (y.hitMap == undefined || y.hitMap.trim().length == 0) {
            this.errorObject.hit_map_empty = {
              active: true,
              txt: {
                en: "Mini Game Point Trace: Hit Map should have an image ",
              },
            };
          }
        });
      }
    } catch (error) {}
  }

  private checkMiniGameCodeIsErrorFree(x: any): void {
    try {
      if (x.mg !== undefined && x.mg.type === MINIGAME_TYPE.CODE) {
        toArray(x.mg.puzzle.puzzleData).forEach((y: any) => {
          if (y.a.txt.en.trim().length === 0) {
            this.errorObject.code_valid_answer = {
              active: true,
              txt: {
                en: "Mini Game Code: One Answer should have a value",
              },
            };
          }
          if (
            y.q.txt.en.trim().length == 0 ||
            y.q.txt.en.trim().length > 500 ||
            y.q.txt.en.toLowerCase().includes("archetypal")
          ) {
            this.errorObject.code_question = {
              active: true,
              txt: {
                en:
                  "Mini Game Code:: Question should have a value, not greater than 500 and does not contain archetypal ",
              },
            };
          }
        });
      }
    } catch (error) {}
  }

  private checkMiniGameLockpickIsErrorFree(x: any): void {
    try {
      if (x.mg !== undefined && x.mg.type === MINIGAME_TYPE.LOCKPICK) {
        toArray(x.mg.puzzle.puzzleData).forEach((y: any) => {
          if (!isNumber(y.pins) || (y.pins < 3 && y.pins > 5)) {
            this.errorObject.lockpick_pins = {
              active: true,
              txt: {
                en:
                  "Mini Game Lock pick: Pins should be a number and between 3-5",
              },
            };
          }
          if (!isNumber(y.scale) || (y.scale < 1 && y.scale > 5)) {
            this.errorObject.lockpick_hit_zone = {
              active: true,
              txt: {
                en:
                  "Mini Game Lock pick: Hit Zone should be a number and between -5",
              },
            };
          }
          if (!isNumber(y.speed) || (y.speed < 1 && y.speed > 6)) {
            this.errorObject.lockpick_speed = {
              active: true,
              txt: {
                en:
                  "Mini Game Lock pick: Speed should be a number and between 1-6",
              },
            };
          }
        });
      }
    } catch (error) {}
  }
  private checkMiniGameTileIsErrorFree(x: any): void {
    try {
      if (x.mg !== undefined && x.mg.type === MINIGAME_TYPE.TILE) {
        toArray(x.mg.puzzle.puzzleData).forEach((y: any) => {
          if (!isNumber(y.divs) || (y.divs < 3 && y.divs > 5)) {
            this.errorObject.tile_division = {
              active: true,
              txt: {
                en:
                  "Mini Game Tile: Divisons should be a number and between 3-5",
              },
            };
          }
          if (!isNumber(y.shuffles) || (y.shuffles < 5 && y.shuffles > 20)) {
            this.errorObject.tile_shuffles = {
              active: true,
              txt: {
                en:
                  "Mini Game Tile: Shuffles should be a number and between 5-20",
              },
            };
          }
          if (y.imgs === undefined || y.imgs.trim().length === 0) {
            this.errorObject.tile_no_image = {
              active: true,
              txt: {
                en: "Mini Game tile: Image should have an value",
              },
            };
          }
        });
      }
    } catch (error) {}
  }
  private checkMiniGameMicrophoneIsErrorFree(x: any): void {
    try {
      if (x.mg !== undefined && x.mg.type === MINIGAME_TYPE.MIC) {
        toArray(x.mg.puzzle.puzzleData).forEach((y: any) => {
          if (
            !isNumber(y.bleedRate_Scalar) ||
            (y.bleedRate_Scalar < 0 && y.bleedRate_Scalar > 1)
          ) {
            this.errorObject.microphone_bleed_rate = {
              active: true,
              txt: {
                en:
                  "Mini Game Microphone: Bleed Rate should be a number and between 0.0-1.0",
              },
            };
          }
        });
      }
    } catch (error) {}
  }
  private checkMiniGameShakeIsErrorFree(x: any): void {
    try {
      if (x.mg !== undefined && x.mg.type === MINIGAME_TYPE.SHAKE) {
        toArray(x.mg.puzzle.puzzleData).forEach((y: any) => {
          if (
            !isNumber(y.bleedRate_Scalar) ||
            (y.bleedRate_Scalar < 0 && y.bleedRate_Scalar > 1)
          ) {
            this.errorObject.shake_bleed_rate = {
              active: true,
              txt: {
                en:
                  "Mini Game Shake: Bleed Rate should be a number and between 0.0-1.0",
              },
            };
          }
        });
      }
    } catch (error) {}
  }
  private checkMiniGameSwipeImageIsErrorFree(x: any): void {
    try {
      if (x.mg !== undefined && x.mg.type === MINIGAME_TYPE.SWIPE_IMG) {
        toArray(x.mg.puzzle.puzzleData).forEach((y: any) => {
          if (
            !isNumber(y.completionPC) ||
            (y.completionPC < 0 && y.completionPC > 100)
          ) {
            this.errorObject.swipe_completion = {
              active: true,
              txt: {
                en:
                  "Mini Game Swipe Image: Completion PC should be a number and between 0-100",
              },
            };
          }
          if (y.imgs === undefined || y.imgs[0].trim().length === 0) {
            this.errorObject.swipe_hidden_image = {
              active: true,
              txt: {
                en: "Mini Game Swipe Image: Hidden Image should have an value",
              },
            };
          }
          if (y.imgs === undefined || y.imgs[1].trim().length === 0) {
            this.errorObject.swipe_overlay_image = {
              active: true,
              txt: {
                en: "Mini Game Swipe Image: Overlay Image should have an value",
              },
            };
          }
        });
      }
    } catch (error) {}
  }
  private checkMiniGameMapRunawayIsErrorFree(x: any): void {
    try {
      if (x.mg !== undefined && x.mg.type === MINIGAME_TYPE.MAP_RUNAWAY) {
        toArray(x.mg.puzzle.puzzleData).forEach((y: any) => {
          if (!isNumber(y.timeout_Adjust_s)) {
            this.errorObject.map_runaway_timer = {
              active: true,
              txt: {
                en: "Mini Game Map Runaway: Timer should be a number",
              },
            };
          }
          if (y.targets === undefined || y.targets.length === 0) {
            this.errorObject.map_runaway_targets = {
              active: true,
              txt: {
                en: "Mini Game Map Runaway: There should be a target specified",
              },
            };
          }
        });
      }
    } catch (error) {}
  }
  private checkMiniGameTapItIsErrorFree(x: any): void {
    try {
      if (x.mg !== undefined && x.mg.type === MINIGAME_TYPE.TAP) {
        toArray(x.mg.puzzle.puzzleData).forEach((y: any) => {
          if (
            !isNumber(y.bleedRate_Scalar) ||
            (y.bleedRate_Scalar < 0 && y.bleedRate_Scalar > 1)
          ) {
            this.errorObject.tap_it_bleed_rate = {
              active: true,
              txt: {
                en:
                  "Mini Game Tap It: Bleed Rate should be a number and between 0.0-1.0",
              },
            };
          }
        });
      }
    } catch (error) {}
  }
  private checkMiniGameColorMatchIsErrorFree(x: any): void {
    try {
      if (x.mg !== undefined && x.mg.type === MINIGAME_TYPE.COLOUR_MATCH) {
        toArray(x.mg.puzzle.puzzleData).forEach((y: any) => {
          if (!isNumber(y.sPerRound) || y.sPerRound < 0) {
            this.errorObject.colour_match_secs_per_round = {
              active: true,
              txt: {
                en:
                  "Mini Game Colour Match: Colour should be a number and greater than 0",
              },
            };
          }
          if (!isNumber(y.numRounds) || y.numRounds < 0) {
            this.errorObject.colour_match_num_rounds = {
              active: true,
              txt: {
                en:
                  "Mini Game Colour Match: Rounds should be a number and greater than 0",
              },
            };
          }
        });
      }
    } catch (error) {}
  }

  private checkMiniGameImageMatchIsErrorFree(x: any): void {
    try {
      if (x.mg !== undefined && x.mg.type === MINIGAME_TYPE.IMAGE_MATCH) {
        toArray(x.mg.puzzle.puzzleData).forEach((y: any) => {
          if (!isNumber(y.numRounds) || y.numRounds < 0) {
            this.errorObject.img_match_rounds = {
              active: true,
              txt: {
                en:
                  "Mini Game Image Match: Round should be a number and greater than 0",
              },
            };
          }
          if (!isNumber(y.cells) || (y.cells <= 10 && y.cells >= 25)) {
            this.errorObject.img_match_cells = {
              active: true,
              txt: {
                en:
                  "Mini Game Image Match: Cells should be a number and between 10-25",
              },
            };
          }
        });
      }
    } catch (error) {}
  }

  private checkMiniGameNumberMatchIsErrorFree(x: any): void {
    try {
      if (x.mg !== undefined && x.mg.type === MINIGAME_TYPE.NUMBER_JUMP) {
        toArray(x.mg.puzzle.puzzleData).forEach((y: any) => {
          if (!isNumber(y.numRounds) || y.numRounds <= 0) {
            this.errorObject.number_jump_num_rounds = {
              active: true,
              txt: {
                en:
                  "Mini Game Number Jump: Rounds should be a number and greater than 0",
              },
            };
          }
          if (!isNumber(y.cells) || (y.cells < 4 && y.cells > 8)) {
            this.errorObject.number_jump_cell = {
              active: true,
              txt: {
                en:
                  "Mini Game Number Jump: Cells should be a number and between 4-8",
              },
            };
          }
          if (
            !isNumber(y.maxRange) ||
            (y.maxRange <= 10 && y.maxRange >= 100)
          ) {
            this.errorObject.number_jump_range = {
              active: true,
              txt: {
                en:
                  "Mini Game Number Jump: Max Range should be a number and between 10-100",
              },
            };
          }
        });
      }
    } catch (error) {}
  }
  private checkMiniGameSymbolTrainIsErrorFree(x: any): void {
    try {
      if (x.mg !== undefined && x.mg.type === MINIGAME_TYPE.SYMBOL_TRAIN) {
        toArray(x.mg.puzzle.puzzleData).forEach((y: any) => {
          if (
            !isNumber(y.num_targets) ||
            (y.num_targets < 1 && y.num_targets > 6)
          ) {
            this.errorObject.symbol_train_num_targets = {
              active: true,
              txt: {
                en:
                  "Mini Game Symbol Train: Num Targets should be a number and between 1-6",
              },
            };
          }
          if (!isNumber(y.speed) || (y.speed < 0 && y.speed > 1)) {
            this.errorObject.symbol_train_speed_multipler = {
              active: true,
              txt: {
                en:
                  "Mini Game Symbol Train: Speed Multipler should be a number and between 0.0-1.0",
              },
            };
          }
        });
      }
    } catch (error) {}
  }

  private checkMiniGameSweetSpotIsErrorFree(x: any): void {
    try {
      if (x.mg !== undefined && x.mg.type === MINIGAME_TYPE.SWEET_SPOT) {
        toArray(x.mg.puzzle.puzzleData).forEach((y: any) => {
          if (!isNumber(y.range_pc) || (y.range_pc < 0 && y.range_pc > 1)) {
            this.errorObject.sweet_spot_range = {
              active: true,
              txt: {
                en:
                  "Mini Game Sweet Spot: Range should be a number and between 0.0-1.0",
              },
            };
          }
          if (!isNumber(y.speed) || (y.speed < 0 && y.speed > 1)) {
            this.errorObject.sweet_spot_speed_multipler = {
              active: true,
              txt: {
                en:
                  "Mini Game Sweet Spot: Speed Multipler should be a number and between 0.0-1.0",
              },
            };
          }
          if (
            !isNumber(y.target_val) ||
            (y.target_val < 0 && y.target_val > 1)
          ) {
            this.errorObject.sweet_spot_targets_value = {
              active: true,
              txt: {
                en:
                  "Mini Game Sweet Spot: Target Value should be a number and between 0.0-1.0",
              },
            };
          }
        });
      }
    } catch (error) {}
  }

  private checkMiniGameMarbleMazeIsErrorFree(x: any): void {
    try {
      if (x.mg !== undefined && x.mg.type === MINIGAME_TYPE.MARBLE_MAZE) {
        toArray(x.mg.puzzle.puzzleData).forEach((y: any) => {
          if (!isNumber(y.numRounds) || (y.numRounds < 1 && y.numRounds > 10)) {
            this.errorObject.marble_maze_num_rounds = {
              active: true,
              txt: {
                en:
                  "Mini Game Marble Maze: Range should be a number and between 1-10",
              },
            };
          }
        });
      }
    } catch (error) {}
  }
  private checkMiniGamePoiPickerIsErrorFree(x: any): void {
    try {
      if (x.mg !== undefined && x.mg.type === MINIGAME_TYPE.POI_PICKER) {
        toArray(x.mg.puzzle.puzzleData).forEach((y: any) => {
          if (y.poi_targets === undefined || y.poi_targets.length === 0) {
            this.errorObject.picker_puzzle_set_targets = {
              active: true,
              txt: {
                en: "Mini Game Poi Picker: Poi Picker should have a target",
              },
            };
          }
        });
      }
    } catch (error) {}
  }
  private checkMiniGameInventoryPickerIsErrorFree(x: any): void {
    try {
      if (x.mg !== undefined && x.mg.type === MINIGAME_TYPE.INVENTORY_PICKER) {
        toArray(x.mg.puzzle.puzzleData).forEach((y: any) => {
          if (y.inv_targets === undefined || y.inv_targets.length === 0) {
            this.errorObject.inventory_puzzle_set_targets = {
              active: true,
              txt: {
                en:
                  "Mini Game Inventory Picker: Inventory should have a target",
              },
            };
          }
        });
      }
    } catch (error) {}
  }

  private isTargetPoiMissing(x: any): void {
    try {
      if (x.mg !== undefined && x.mg.type === MINIGAME_TYPE.INVENTORY_PICKER) {
        toArray(x.mg.puzzle.puzzleData).forEach((y: any) => {
          if (y.inv_targets === undefined || y.inv_targets.length === 0) {
            this.errorObject.inventory_puzzle_set_targets = {
              active: true,
              txt: {
                en:
                  "Mini Game Inventory Picker: Inventory should have a target",
              },
            };
          }
        });
      }
    } catch (error) {}
  }

  private isDialogTargetPoiMissing(x: any): void {
    try {
      if (x.d1.actions !== undefined) {
        if (x.d1.actions.poiActiveAction !== undefined) {
          toArray(x.d1.actions.poiActiveAction.upd).forEach((y: any) => {
            if (this.doesPoiExistAnymore(y.id)) {
              this.errorObject.dialog_one_poiActiveAction_mia = {
                active: true,
                txt: {
                  en:
                    "Dialog One: Poi Active Action POI (" +
                    y.id +
                    ") does not exist anymore",
                },
              };
            }
          });
        }
        if (x.d1.poiVisibleAction !== undefined) {
          toArray(x.d1.actions.poiVisibleAction.upd).forEach((y: any) => {
            if (this.doesPoiExistAnymore(y.id)) {
              this.errorObject.dialog_one_poiVisibleAction_mia = {
                active: true,
                txt: {
                  en:
                    "Dialog one: Poi Visibility Action POI (" +
                    y.id +
                    ") does not exist anymore",
                },
              };
            }
          });
        }
        if (x.d1.invAction !== undefined) {
          toArray(x.d1.invAction.upd).forEach((y: any) => {
            if (this.doesInventoryExistAnymore(y.id)) {
              this.errorObject.dialog_one_invAction_mia = {
                active: true,
                txt: {
                  en:
                    "Dialog One: Inventory Item Missing (" +
                    y.id +
                    ") does not exist anymore",
                },
              };
            }
          });
        }

        if (x.d1.qStatusAction !== undefined) {
          toArray(x.d1.qStatusAction.upd).forEach((y: any) => {
            if (this.doesQuestExistAnymore(y.id)) {
              this.errorObject.dialog_one_qStatusAction_mia = {
                active: true,
                txt: {
                  en:
                    "Dialog One: Quest Status Missing (" +
                    y.id +
                    ") does not exist anymore",
                },
              };
            }
          });
        }
      }
      if (x.d2 !== undefined && x.d2.actions !== undefined) {
        if (x.d2.poiActiveAction !== undefined) {
          toArray(x.d2.actions.poiActiveAction.upd).forEach((y: any) => {
            if (this.doesPoiExistAnymore(y.id)) {
              this.errorObject.dialog_two_poiActiveAction_mia = {
                active: true,
                txt: {
                  en:
                    "Dialog Two: Poi Active Action POI (" +
                    y.id +
                    ") does not exist anymore",
                },
              };
            }
          });
        }
        if (x.d2.poiVisibleAction !== undefined) {
          toArray(x.d2.actions.poiVisibleAction.upd).forEach((y: any) => {
            if (this.doesPoiExistAnymore(y.id)) {
              this.errorObject.dialog_two_poiVisibleAction_mia = {
                active: true,
                txt: {
                  en:
                    "Dialog Two: Poi Visibility Action POI (" +
                    y.id +
                    ") does not exist anymore",
                },
              };
            }
          });
        }
        if (x.d2.invAction !== undefined) {
          toArray(x.d2.invAction.upd).forEach((y: any) => {
            if (this.doesInventoryExistAnymore(y.id)) {
              this.errorObject.dialog_two_invAction_mia = {
                active: true,
                txt: {
                  en:
                    "Dialog Two: Inventory Item Missing (" +
                    y.id +
                    ") does not exist anymore",
                },
              };
            }
          });
        }

        if (x.d2.qStatusAction !== undefined) {
          toArray(x.d2.qStatusAction.upd).forEach((y: any) => {
            if (this.doesQuestExistAnymore(y.id)) {
              this.errorObject.dialog_two_qStatusAction_mia = {
                active: true,
                txt: {
                  en:
                    "Dialog Two: Quest Status Missing (" +
                    y.id +
                    ") does not exist anymore",
                },
              };
            }
          });
        }
      }
    } catch (error) {}
  }

  private isMGOnFailTargetPoiMissing(x: any): void {
    try {
      if (x.mg !== undefined) {
        Object.keys(x.mg.puzzle.puzzleData).forEach((difficulty: any) => {
          if (
            x.mg.puzzle.puzzleData[difficulty].onFail.actions
              .poiActiveAction !== undefined
          ) {
            if (
              x.mg.puzzle.puzzleData[difficulty].onFail.actions
                .poiActiveAction !== undefined
            ) {
              toArray(
                x.mg.puzzle.puzzleData[difficulty].onFail.actions
                  .poiActiveAction.upd
              ).forEach((y: any) => {
                if (this.doesPoiExistAnymore(y.id)) {
                  this.errorObject.mg_onfail_poiActiveAction_mia = {
                    active: true,
                    txt: {
                      en:
                        "Mini Game On Fail: Poi Active Action POI (" +
                        y.id +
                        ") does not exist anymore",
                    },
                  };
                }
              });
            }
            if (
              x.mg.puzzle.puzzleData[difficulty].onFail.actions
                .poiVisibleAction !== undefined
            ) {
              toArray(
                x.mg.puzzle.puzzleData[difficulty].onFail.actions
                  .poiVisibleAction.upd
              ).forEach((y: any) => {
                if (this.doesPoiExistAnymore(y.id)) {
                  this.errorObject.mg_onfail_poiVisibleAction_mia = {
                    active: true,
                    txt: {
                      en:
                        "Mini Game On Fail: Poi Visiblity Action POI (" +
                        y.id +
                        ") does not exist anymore",
                    },
                  };
                }
              });
            }
            if (
              x.mg.puzzle.puzzleData[difficulty].onFail.actions.invAction !==
              undefined
            ) {
              toArray(
                x.mg.puzzle.puzzleData[difficulty].onFail.actions.invAction.upd
              ).forEach((y: any) => {
                if (this.doesInventoryExistAnymore(y.id)) {
                  this.errorObject.mg_onfail_invAction_mia = {
                    active: true,
                    txt: {
                      en:
                        "Mini Game On Fail: Inventory Item Missing (" +
                        y.id +
                        ") does not exist anymore",
                    },
                  };
                }
              });
            }

            if (
              x.mg.puzzle.puzzleData[difficulty].onFail.actions
                .qStatusAction !== undefined
            ) {
              toArray(
                x.mg.puzzle.puzzleData[difficulty].onFail.actions.qStatusAction
                  .upd
              ).forEach((y: any) => {
                if (this.doesQuestExistAnymore(y.id)) {
                  this.errorObject.mg_onfail_qStatusAction_mia = {
                    active: true,
                    txt: {
                      en:
                        "Mini Game On Fail: Quest Status Missing (" +
                        y.id +
                        ") does not exist anymore",
                    },
                  };
                }
              });
            }
          }
        });
      }
    } catch (error) {}
  }
  private isMGOnIncorrectTargetPoiMissing(x: any): void {
    try {
      if (x.mg !== undefined) {
        Object.keys(x.mg.puzzle.puzzleData).forEach((difficulty: any) => {
          if (
            x.mg.puzzle.puzzleData[difficulty].onIncorrect.actions
              .poiActiveAction !== undefined
          ) {
            if (
              x.mg.puzzle.puzzleData[difficulty].onIncorrect.actions
                .poiActiveAction !== undefined
            ) {
              toArray(
                x.mg.puzzle.puzzleData[difficulty].onIncorrect.actions
                  .poiActiveAction.upd
              ).forEach((y: any) => {
                if (this.doesPoiExistAnymore(y.id)) {
                  this.errorObject.mg_onincorrect_poiActiveAction_mia = {
                    active: true,
                    txt: {
                      en:
                        "Mini Game On Incorrect: Poi Active Action POI (" +
                        y.id +
                        ") does not exist anymore",
                    },
                  };
                }
              });
            }
            if (
              x.mg.puzzle.puzzleData[difficulty].onIncorrect.actions
                .poiVisibleAction !== undefined
            ) {
              toArray(
                x.mg.puzzle.puzzleData[difficulty].onIncorrect.actions
                  .poiVisibleAction.upd
              ).forEach((y: any) => {
                if (this.doesPoiExistAnymore(y.id)) {
                  this.errorObject.mg_onincorrect_poiVisibleAction_mia = {
                    active: true,
                    txt: {
                      en:
                        "Mini Game On Incorrect: Poi Visiblity Action POI (" +
                        y.id +
                        ") does not exist anymore",
                    },
                  };
                }
              });
            }
            if (
              x.mg.puzzle.puzzleData[difficulty].onIncorrect.actions
                .qStatusAction !== undefined
            ) {
              toArray(
                x.mg.puzzle.puzzleData[difficulty].onIncorrectactions
                  .poiVisibleAction.upd
              ).forEach((y: any) => {
                if (this.doesQuestExistAnymore(y.id)) {
                  this.errorObject.mg_onincorrect_qStatusAction_mia = {
                    active: true,
                    txt: {
                      en:
                        "Mini Game On Incorrect: Quest Status Missing (" +
                        y.id +
                        ") does not exist anymore",
                    },
                  };
                }
              });
            }
            if (
              x.mg.puzzle.puzzleData[difficulty].onIncorrect.actions
                .invAction !== undefined
            ) {
              toArray(
                x.mg.puzzle.puzzleData[difficulty].onIncorrectactions.invAction
                  .upd
              ).forEach((y: any) => {
                if (this.doesInventoryExistAnymore(y.id)) {
                  this.errorObject.mg_onincorrect_invAction_mia = {
                    active: true,
                    txt: {
                      en:
                        "Mini Game On Incorrect: Inventory Item Missing (" +
                        y.id +
                        ") does not exist anymore",
                    },
                  };
                }
              });
            }
          }
        });
      }
    } catch (error) {}
  }

  private isMGOnSuccessTargetPoiMissing(x: any): void {
    try {
      if (x.mg !== undefined) {
        Object.keys(x.mg.puzzle.puzzleData).forEach((difficulty: any) => {
          if (
            x.mg.puzzle.puzzleData[difficulty].onSuccess.actions !== undefined
          ) {
            if (
              x.mg.puzzle.puzzleData[difficulty].onSuccess.actions
                .poiActiveAction !== undefined
            ) {
              toArray(
                x.mg.puzzle.puzzleData[difficulty].onSuccess.actions
                  .poiActiveAction.upd
              ).forEach((y: any) => {
                if (this.doesPoiExistAnymore(y.id)) {
                  this.errorObject.mg_onsuccess_poiActiveAction_mia = {
                    active: true,
                    txt: {
                      en:
                        "Mini Game On Success: Poi Active Action POI (" +
                        y.id +
                        ") does not exist anymore",
                    },
                  };
                }
              });
            }
            if (
              x.mg.puzzle.puzzleData[difficulty].onSuccess.actions
                .poiVisibleAction !== undefined
            ) {
              toArray(
                x.mg.puzzle.puzzleData[difficulty].onSuccess.actions
                  .poiVisibleAction.upd
              ).forEach((y: any) => {
                if (this.doesPoiExistAnymore(y.id)) {
                  this.errorObject.mg_onsuccess_poiVisibleAction_mia = {
                    active: true,
                    txt: {
                      en:
                        "Mini Game On Success: Poi Active Action POI (" +
                        y.id +
                        ") does not exist anymore",
                    },
                  };
                }
              });
            }
            if (
              x.mg.puzzle.puzzleData[difficulty].onSuccess.actions
                .qStatusAction !== undefined
            ) {
              toArray(
                x.mg.puzzle.puzzleData[difficulty].onSuccess.actions
                  .qStatusAction.upd
              ).forEach((y: any) => {
                if (this.doesQuestExistAnymore(y.id)) {
                  this.errorObject.mg_onsuccess_qStatusAction_mia = {
                    active: true,
                    txt: {
                      en:
                        "Mini Game On Success: Quest Status Missing (" +
                        y.id +
                        ") does not exist anymore",
                    },
                  };
                }
              });
            }
            if (
              x.mg.puzzle.puzzleData[difficulty].onSuccess.actions.invAction !==
              undefined
            ) {
              toArray(
                x.mg.puzzle.puzzleData[difficulty].onSuccess.actions.invAction
                  .upd
              ).forEach((y: any) => {
                if (this.doesInventoryExistAnymore(y.id)) {
                  this.errorObject.mg_onsuccess_invAction_mia = {
                    active: true,
                    txt: {
                      en:
                        "Mini Game On Success: Inventory Item Missing (" +
                        y.id +
                        ") does not exist anymore",
                    },
                  };
                }
              });
            }
          }
        });
      }
    } catch (error) {}
  }

  private isMGFinalTargetPoiMissing(x: any): void {
    try {
      if (x.mg !== undefined && x.actions !== undefined) {
        if (x.mg.actions.poiActiveAction !== undefined) {
          toArray(x.mg.actions.poiActiveAction.upd).forEach((y: any) => {
            if (this.doesPoiExistAnymore(y.id)) {
              this.errorObject.mg_final_poiActiveAction_mia = {
                active: true,
                txt: {
                  en:
                    "Mini Game Final: Poi Active Action POI (" +
                    y.id +
                    ") does not exist anymore",
                },
              };
            }
          });
        }
        if (x.mg.actions.poiVisibleAction !== undefined) {
          toArray(x.mg.actions.poiVisibleAction.upd).forEach((y: any) => {
            if (this.doesPoiExistAnymore(y.id)) {
              this.errorObject.mg_final_poiVisibleAction_mia = {
                active: true,
                txt: {
                  en:
                    "Mini Game Final: Poi Visible Action POI (" +
                    y.id +
                    ") does not exist anymore",
                },
              };
            }
          });
        }
        if (x.mg.actions.invAction !== undefined) {
          toArray(x.mg.actions.invAction.upd).forEach((y: any) => {
            if (this.doesQuestExistAnymore(y.id)) {
              this.errorObject.mg_final_invAction_mia = {
                active: true,
                txt: {
                  en:
                    "Mini Game Final: Inventory Item Missing (" +
                    y.id +
                    ") does not exist anymore",
                },
              };
            }
          });
        }
        if (x.mg.actions.qStatusAction !== undefined) {
          toArray(x.mg.actions.poiVisibleAction.upd).forEach((y: any) => {
            if (this.doesQuestExistAnymore(y.id)) {
              this.errorObject.mg_final_qStatusAction_mia = {
                active: true,
                txt: {
                  en:
                    "Mini Game Final: Quest Status Missing (" +
                    y.id +
                    ") does not exist anymore",
                },
              };
            }
          });
        }
      }
    } catch (error) {}
  }

  private isDialogQuestionAnswerMia(x: any): void {
    try {
      if (x.d1 !== undefined && x.d1.questions !== undefined) {
        toArray(x.d1.questions).forEach((y: any) => {
          if (y.q.en.trim().length < 3) {
            this.errorObject.dialog_question_q_mia = {
              txt: {
                en:
                  "Dialog Question: Dialog Question is missing or has less than 3 characters",
              },
              active: true,
            };
          }
          if (y.a.en.trim().length < 3) {
            this.errorObject.dialog_question_a_mia = {
              txt: {
                en:
                  "Dialog Question: Dialog Answer is missing or has less than 3 characters",
              },
              active: true,
            };
          }
        });
      }
    } catch (error) {}
  }

  private isDialogTwoQuestionAnswerMia(x: any): void {
    try {
      if (x.d2 !== undefined && x.d2.questions !== undefined) {
        toArray(x.d2.questions).forEach((y: any) => {
          if (y.q.en.trim().length < 3) {
            this.errorObject.dialog_two_question_q_mia = {
              txt: {
                en:
                  "Dialog 2 Question: Dialog Question is missing or has less than 3 characters",
              },
              active: true,
            };
          }
          if (y.a.en.trim().length < 3) {
            this.errorObject.dialog_two_question_a_mia = {
              txt: {
                en:
                  "Dialog 2 Question: Dialog Answer is missing or has less than 3 characters",
              },
              active: true,
            };
          }
        });
      }
    } catch (error) {}
  }

  private isDialogQuestionTargetPoiMissing(x: any): void {
    try {
      if (x.d1 !== undefined && x.d1.questions !== undefined) {
        toArray(x.d1.questions).forEach((z: any) => {
          if (
            z.action !== undefined &&
            z.actions.poiActiveAction !== undefined
          ) {
            toArray(z.actions.poiActiveAction.upd).forEach((y: any) => {
              if (this.doesPoiExistAnymore(y.id)) {
                this.errorObject.dialog_question_poiActiveAction_mia = {
                  active: true,
                  txt: {
                    en:
                      "Dialog Question: Poi Active Action POI (" +
                      y.id +
                      ") does not exist anymore",
                  },
                };
              }
            });
          }
          if (
            z.action !== undefined &&
            z.actions.poiVisibleAction !== undefined
          ) {
            toArray(z.actions.poiVisibleAction.upd).forEach((y: any) => {
              if (this.doesPoiExistAnymore(y.id)) {
                this.errorObject.dialog_question_poiVisibleAction_mia = {
                  active: true,
                  txt: {
                    en:
                      "Dialog Question: Poi Visible Action POI (" +
                      y.id +
                      ") does not exist anymore",
                  },
                };
              }
            });
          }
          if (z.action !== undefined && z.actions.invAction !== undefined) {
            toArray(z.actions.invAction.upd).forEach((y: any) => {
              if (this.doesInventoryExistAnymore(y.id)) {
                this.errorObject.dialog_question_invAction_mia = {
                  active: true,
                  txt: {
                    en:
                      "Dialog Question: Inventory Item Missing (" +
                      y.id +
                      ") does not exist anymore",
                  },
                };
              }
            });
          }
          if (z.action !== undefined && z.actions.qStatusAction !== undefined) {
            toArray(z.d1.questions.actions.poiVisibleAction.upd).forEach(
              (y: any) => {
                if (this.doesQuestExistAnymore(y.id)) {
                  this.errorObject.dialog_question_qStatusAction_mia = {
                    active: true,
                    txt: {
                      en:
                        "Dialog Question: Quest Status Missing (" +
                        y.id +
                        ") does not exist anymore",
                    },
                  };
                }
              }
            );
          }
        });
      }
    } catch (error) {}
  }
  private isDialogInventoryCostEmpty(x: any): void {
    try {
      if (x.d1 !== undefined && x.d1.questions !== undefined) {
        toArray(x.d1.questions).forEach((z: any) => {
          if (z.cost !== undefined && z.cost.quantity < 0) {
            this.errorObject.dialog_question_inventory_count_less_zero = {
              active: true,
              txt: {
                en: "Dialog One: Inventory is less than 0",
              },
            };
          }
        });
      }
    } catch (error) {}
  }
  private isDialogTwoInventoryCostEmpty(x: any): void {
    try {
      if (x.d2 !== undefined && x.d2.questions !== undefined) {
        toArray(x.d2.questions).forEach((z: any) => {
          if (z.cost !== undefined && z.cost.quantity < 0) {
            this.errorObject.dialog_two_question_inventory_count_less_zero = {
              active: true,
              txt: {
                en: "Dialog Two: Inventory is less than 0",
              },
            };
          }
        });
      }
    } catch (error) {}
  }
  private isDialogTwoQuestionTargetPoiMissing(x: any): void {
    try {
      if (x.d2 !== undefined && x.d2.questions !== undefined) {
        toArray(x.d2.questions).forEach((z: any) => {
          if (z.actions !== undefined) {
            if (z.actions.poiActiveAction !== undefined) {
              toArray(z.actions.poiActiveAction.upd).forEach((y: any) => {
                if (this.doesPoiExistAnymore(y.id)) {
                  this.errorObject.dialog_two_question_poiActiveAction_mia = {
                    active: true,
                    txt: {
                      en:
                        "Dialog Question: Poi Active Action POI (" +
                        y.id +
                        ") does not exist anymore",
                    },
                  };
                }
              });
            }
            if (z.actions.poiVisibleAction !== undefined) {
              toArray(z.actions.poiVisibleAction.upd).forEach((y: any) => {
                if (this.doesPoiExistAnymore(y.id)) {
                  this.errorObject.dialog_two_question_poiVisibleAction_mia = {
                    active: true,
                    txt: {
                      en:
                        "Dialog Question: Poi Visible Action POI (" +
                        y.id +
                        ") does not exist anymore",
                    },
                  };
                }
              });
            }
            if (z.actions.invAction !== undefined) {
              toArray(z.actions.invAction.upd).forEach((y: any) => {
                if (this.doesInventoryExistAnymore(y.id)) {
                  this.errorObject.dialog_two_question_invAction_mia = {
                    active: true,
                    txt: {
                      en:
                        "Dialog Question: Inventory Item Missing (" +
                        y.id +
                        ") does not exist anymore",
                    },
                  };
                }
              });
            }
            if (z.actions.qStatusAction !== undefined) {
              toArray(z.actions.poiVisibleAction.upd).forEach((y: any) => {
                if (this.doesQuestExistAnymore(y.id)) {
                  this.errorObject.dialog_two_question_qStatusAction_mia = {
                    active: true,
                    txt: {
                      en:
                        "Dialog Question: Quest Status Missing (" +
                        y.id +
                        ") does not exist anymore",
                    },
                  };
                }
              });
            }
          }
        });
      }
    } catch (error) {}
  }

  private doesMapRunawayPoiExist(x: any): void {
    try {
      if (x.mg !== undefined && x.mg.type === "map_runaway") {
        Object.keys(x.mg.puzzle.puzzleData).forEach((difficulty: any) => {
          if (x.mg.puzzle.puzzleData[difficulty].targets !== undefined) {
            toArray(x.mg.puzzle.puzzleData[difficulty].targets).forEach(
              (y: any) => {
                if (this.doesPoiExistAnymore(y.id)) {
                  this.errorObject.map_runaway_target_mia = {
                    active: true,
                    txt: {
                      en:
                        "Mini Game Map Runaway: Map runaway POI does not exist anymore (" +
                        y.id +
                        ")",
                    },
                  };
                }
              }
            );
          }
        });
      }
    } catch (error) {}
  }

  private doesPoiPickerPoiExist(x: any): void {
    try {
      if (x.mg !== undefined && x.mg.type === "poi-picker") {
        Object.keys(x.mg.puzzle.puzzleData).forEach((difficulty: any) => {
          if (x.mg.puzzle.puzzleData[difficulty].poi_targets !== undefined) {
            toArray(x.mg.puzzle.puzzleData[difficulty].poi_targets).forEach(
              (y: any) => {
                if (this.doesPoiExistAnymore(y.id)) {
                  this.errorObject.poi_picker_target_mia = {
                    active: true,
                    txt: {
                      en:
                        "Mini Game Poi Picker: Map Poi Picker does not exist anymore (" +
                        y.id +
                        ")",
                    },
                  };
                }
              }
            );
          }
        });
      }
    } catch (error) {}
  }

  private isPoiPickerTargetSelected(x: any): void {
    try {
      if (x.mg !== undefined && x.mg.type === "poi-picker") {
        Object.keys(x.mg.puzzle.puzzleData).forEach((difficulty: any) => {
          if (x.mg.puzzle.puzzleData[difficulty].poi_targets !== undefined) {
            const y = toArray(x.mg.puzzle.puzzleData[difficulty].poi_targets);
            if (y.filter((value: any) => value.value === true).length == 0) {
              this.errorObject.poi_picker_target_selected = {
                active: true,
                txt: {
                  en:
                    "Mini Game Poi Picker: Poi Picker does not have a targeted selected",
                },
              };
            }
          }
        });
      }
    } catch (error) {}
  }

  private doesInventoryPickerPoiExist(x: any): void {
    try {
      if (x.mg !== undefined && x.mg.type === "inventory-picker") {
        Object.keys(x.mg.puzzle.puzzleData).forEach((difficulty: any) => {
          if (x.mg.puzzle.puzzleData[difficulty].inv_targets !== undefined) {
            toArray(x.mg.puzzle.puzzleData[difficulty].inv_targets).forEach(
              (y: any) => {
                if (this.doesInventoryExistAnymore(y.id)) {
                  this.errorObject.inventory_picker_target_mia = {
                    active: true,
                    txt: {
                      en:
                        "Mini Game Inventory: Inventory Item does not exist anymore (" +
                        y.id +
                        ")",
                    },
                  };
                }
              }
            );
          }
        });
      }
    } catch (error) {}
  }

  private isInventoryTargetSelected(x: any): void {
    try {
      if (x.mg !== undefined && x.mg.type === "inventory-picker") {
        Object.keys(x.mg.puzzle.puzzleData).forEach((difficulty: any) => {
          if (x.mg.puzzle.puzzleData[difficulty].inv_targets !== undefined) {
            const y = toArray(x.mg.puzzle.puzzleData[difficulty].inv_targets);
            if (y.filter((value: any) => value.value === true).length == 0) {
              this.errorObject.inventory_picker_target_selected = {
                active: true,
                txt: {
                  en:
                    "Mini Game Inventory: Inventory Item does not have a targeted selected",
                },
              };
            }
          }
        });
      }
    } catch (error) {}
  }

  private doesPoiExistAnymore(poiKey: string): boolean {
    const filterArray = this.mapPoiArray.filter(
      (x: QuestMapPoi) => x.key === poiKey
    );
    if (filterArray.length == 0) {
      return true;
    }
    return false;
  }

  private doesQuestExistAnymore(questId: string): boolean {
    const filterArray = this.questData.filter((x: Quests) => x.key === questId);
    if (filterArray.length == 0) {
      return true;
    }
    return false;
  }
  private doesInventoryExistAnymore(inventoryId: string): boolean {
    const inv_items = Object.values(this.seasonData.inv_items);
    const filterArray = inv_items.filter(
      (x: InvItem) => x.slug === inventoryId
    );
    if (filterArray.length == 0) {
      return true;
    }
    return false;
  }
}
